// Must be first: guards React's DOM commits against Google-Translate-style
// external DOM mutation before any component renders.
import './utils/translateGuard';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Main from './main'; // Import the new Main component
import './index.css';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<Main />);
